<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': info }" data-toggle="tab" href="#pills-info"
                        (click)="ver('info')">
                        <span class="nav-text">
                            Pet Info
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': physical }" id="pills-physical-tab" data-toggle="tab"
                        data-bs-target="#pills-physical" href="#pills-physical" (click)="ver('physical')">
                        Metrics
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': parameters }" id="pills-parameters-tab" data-toggle="tab"
                        data-bs-target="#pills-parameters" href="#pills-parameters" (click)="ver('parameters')">
                        Parameters
                    </a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': assoc }" id="pills-assoc-tab" data-toggle="tab"
                        data-bs-target="#pills-assoc" href="#pills-assoc" (click)="ver('assoc')">
                        Assoc. People
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': referred }" id="pills-referred-tab" data-toggle="tab"
                        data-bs-target="#pills-referred" href="#pills-referred" (click)="ver('referred')">
                        Appointment - Referred
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': financial }" id="pills-financial-tab" data-toggle="tab"
                        data-bs-target="#pills-financial" href="#pills-financial" (click)="ver('financial')">
                        Financial
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': notes }" id="pills-notes-tab" data-toggle="tab"
                        data-bs-target="#pills-notes" href="#pills-notes" (click)="ver('notes')">
                        Pet Notes
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': documents }" id="pills-documents-tab" data-toggle="tab"
                        data-bs-target="#pills-documents" href="#pills-documents" (click)="ver('documents')">
                        Documents
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{ 'show active': info }" id="pills-info" role="tabpanel"
            aria-labelledby="pills-info-tab">
            <ngx-work-pet-info></ngx-work-pet-info>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': physical }" id="pills-physical" role="tabpanel"
            aria-labelledby="pills-physical-tab">
            <ngx-work-pet-physical [pet_no]="pet_no"></ngx-work-pet-physical>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': parameters }" id="pills-parameters" role="tabpanel"
            aria-labelledby="pills-parameters-tab">
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': assoc }" id="pills-assoc" role="tabpanel"
            aria-labelledby="pills-assoc-tab">
            <ngx-work-associate></ngx-work-associate>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': referred }" id="pills-referred" role="tabpanel"
            aria-labelledby="pills-referred-tab">
            <ngx-work-appt-referred [pet_no]="pet_no"></ngx-work-appt-referred>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': financial }" id="pills-financial" role="tabpanel"
            aria-labelledby="pills-financial-tab">
            <ngx-finance-petlvl [client_no]="client_no" [pet_no]="pet_no"></ngx-finance-petlvl>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': notes }" id="pills-notes" role="tabpanel"
            aria-labelledby="pills-notes-tab">
            <ngx-work-pet-note [pet_no]="pet_no"></ngx-work-pet-note>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': documents }" id="pills-documents" role="tabpanel"
            aria-labelledby="pillsdocuments-tab">
            <ngx-document [client_no]="0" [pet_no]="pet_no"></ngx-document>
        </div>
    </div>
</div>